export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-x-c4233a136327d5109ce2fe397657173f.svg";